import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavItem } from 'reactstrap';

import NavItemMore from './NavItemMore';

const campaignIsActive = (match, location) =>
  !!location.pathname.match(/^\/campaigns/);

function AdOpsNavigation() {
  return (
    <>
      <NavItem>
        <NavLink className="nav-link" to="/dashboard/adops">
          Overview
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className="nav-link"
          to="/campaigns"
          isActive={campaignIsActive}
        >
          Campaigns
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/benchmarks">
          Benchmarks
        </NavLink>
      </NavItem>
      {/*       <NavItem>
        <NavLink className="nav-link" to="/sku-search">
          SKUs
        </NavLink>
      </NavItem> */}
      <NavItemMore
        items={[
          { text: 'Agreements', href: '/agreements' },
          { text: 'Brands', href: '/brands' },
          { text: 'Contacts', href: '/contacts' },
          { text: 'Opportunities', href: '/opportunities' },
          { text: 'Users', href: '/users' },
          { text: 'Invoices', href: '/invoices' },
        ]}
      />
    </>
  );
}

export default AdOpsNavigation;
